import { ENV } from '~/common/enums/enums';
import { SeoPayload } from '~/common/types/types';

const seoPayload: SeoPayload = {
  title: 'seo.onlineEvent.title',
  description: 'seo.onlineEvent.description',
  siteUrl: ENV.APP.URL,
};

export { seoPayload };
